module.exports = __webpack_public_path__ + "img/logo.aaf4909f.svg";